<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fG65GI/tc-custom/9781497671409.jpg?1728851554130" alt="This image is the cover for the book Raven in the Foregate, The Chronicles of Brother Cadfael"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Raven in the Foregate, The Chronicles of Brother Cadfael
      </h1>
      <p class="bookDescription body article font2">
        <b>A despised priest is drowned in a pond in this medieval mystery filled with “</b><b>lively period detail” (<i>Kirkus Reviews</i>).</b><br/><br/> In a mild December in the year of our Lord 1141, a new priest comes to the parishioners of the Foregate outside the Abbey of Saint Peter and Saint Paul. Father Ailnoth brings with him a housekeeper and her nephew—and a disposition that invites murder.<br/>  <br/> Brother Cadfael quickly sees that father Ailnoth is a harsh man who, striding along in his black cassock, looks like a doomsaying raven. The housekeeper’s nephew, Benet, is quite different—a smiling lad, a hard worker in Cadfael’s herb garden, but, as Brother Cadfael soon discovers, an impostor. And when Ailnoth is found drowned, suspicion falls on Benet, though many in the Foregate had cause to want this priest dead. Now Brother Cadfael is gathering clues along with his medicinals to treat a case of unholy passions, tragic politics, and perhaps divine intervention.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellis Peters
      </h2>
      
      <p class="authorDescription body article">Ellis Peters is a pseudonym of Edith Mary Pargeter (1913&ndash;1995), a British author whose Chronicles of Brother Cadfael are credited with popularizing the historical mystery. Cadfael, a Welsh&#160;Benedictine&#160;monk living at&#160;Shrewsbury Abbey in the first half of the twelfth century, has been described as combining the curious mind of a scientist with the bravery of a knight-errant. The character has been adapted for television, and the books drew international attention to Shrewsbury and its history.<BR />&#160;<BR />Pargeter won an Edgar Award&#160;in 1963 for&#160;<I>Death and the Joyful Woman</I>, and in 1993 she won the&#160;Cartier Diamond Dagger, an annual award given by the&#160;Crime Writers&rsquo; Association of Great Britain. She was appointed&#160;officer of the Order of the British Empire&#160;in 1994, and in 1999 the British&#160;Crime Writers&rsquo; Association&#160;established the&#160;Ellis Peters Historical Dagger&#160;award, later called the Ellis Peters Historical Award.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Head of Zeus Ltd.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1594410a